<template>

    <li :id="'navtab' + epIndexTabEdit">
      <a data-toggle="tab" @click.prevent="setActive('ep' + epIndexTabEdit)" :class="{ active: isActive('ep' + epIndexTabEdit) }" :href="'#ep' + epIndexTabEdit">Episode {{ epIndexTabEdit }}</a><span class="label" @click.prevent="removeEpTabEdit"> x </span>
    </li>

</template>

<script>
import axios from 'axios'
import lodash from 'lodash'
const token = localStorage.getItem('token')
export default {
  props: ["epIndexTabEdit"],
  name: 'EpTabAddEdit',
  data () {
    return {

    }
  },
  computed: {
   
  },
  methods:{
    isActive (menuItem) {
      this.$emit('isActive', {menuItem})
      //return this.activeItem === menuItem
    },
    setActive (menuItem) {
      this.$emit('setActive', {menuItem})
      //this.activeItem = menuItem
    },
    removeEpTabEdit() {
      this.$emit('removeEpTabEdit')
    }
   }
  //
}
</script>

<style lang="css" scoped>
</style>


// WEBPACK FOOTER //
// src/components/child/EpTabAddEdit.vue